// //Languages
// const a2aData = {
//     language: 'en',
//     currency: 'EUR' ,
//     height: 76
// };
//
// function updateButtonText() {
//     let lang = document.documentElement.lang;
//     let languageLabel = '';
//     let flagUrl = '';
//
//     switch(lang) {
//         case 'en':
//             languageLabel = 'English';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/en.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/en-lang.svg';
//             lang = 'en';
//             break;
//         case 'fr':
//             languageLabel = 'Français';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/fr.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/fr-lang.svg';
//             lang = 'fr';
//             break;
//         case 'tr':
//             languageLabel = 'Türkçe';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/tr.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/tr-lang.svg';
//             lang = 'tr';
//             break;
//         case 'ru':
//             languageLabel = 'Русский';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/ru.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/ru-lang.svg';
//             lang = 'ru';
//             break;
//         case 'pt':
//             languageLabel = 'Português';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/pt.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/pt-lang.svg';
//             lang = 'pt';
//             break;
//         case 'es':
//             languageLabel = 'Español';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/es.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/es-lang.svg';
//             lang = 'es';
//             break;
//         default:
//             languageLabel = 'English';
//             flagUrl = '/wp-content/plugins/gtranslate/flags/svg/en.svg';
//             flagUrlMobile = '/wp-content/themes/a2a_theme/assets/images/en-lang.svg';
//             lang = 'en';
//             break;
//     }
//
//     document.getElementById('currentLanguage').innerHTML = '<img src="' + flagUrl + '" alt="' + languageLabel + ' Flag"> ' + languageLabel;
//
//     let savedCurrency = localStorage.getItem('selectedCurrency') || 'GBP';
//     document.getElementById('currentLanguageMobile').innerHTML = '<span class="language-label">' + languageLabel + '</span><span class="language-code">' + savedCurrency + '</span><img src="' + flagUrlMobile + '" alt="' + languageLabel + ' Flag">'
//
//     document.querySelectorAll('#languageList li').forEach(function(li) {
//         li.style.display = 'block';
//     });
//
//     document.querySelectorAll('.mobile-view .lang-bar .dropdown-menu ul li').forEach(function(li) {
//         li.style.display = 'block';
//     })
//
//     let currentLangItem = document.querySelector('#languageList li[data-lang="' + lang + '"]');
//     if (currentLangItem) {
//         currentLangItem.style.display = 'none';
//     }
//
//     let currentLangItemMobile = document.querySelector('.mobile-view .lang-bar .dropdown-menu ul li[data-lang="' + lang + '"]');
//     if (currentLangItemMobile) {
//         currentLangItemMobile.style.display = 'none';
//     }
//
//     a2aData.language = lang;
//     setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
// }
//
// document.addEventListener("DOMContentLoaded", function() {
//     updateButtonText();
// });
//
// const observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//         if (mutation.attributeName === "lang") {
//             updateButtonText();
//         }
//     });
// });
//
// observer.observe(document.documentElement, { attributes: true });
//
// //Currencies
// document.addEventListener('DOMContentLoaded', function() {
//     const languageOptions = document.querySelectorAll('.left-side .lang-bar .dropdown-menu ul li a.glink');
//     const languageOptionsMobile = document.querySelectorAll('.mobile-view .lang-bar .dropdown-menu ul li a');
//
//     languageOptions.forEach(option => {
//         option.addEventListener('click', function(e) {
//             a2aData.language = this.getAttribute('data-gt-lang');
//             setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
//         });
//     });
//
//     languageOptionsMobile.forEach(option => {
//         option.addEventListener('click', function(e) {
//             a2aData.language  = this.getAttribute('data-gt-lang');
//             setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
//         });
//     });
//
//     const currentCurrencyBtn = document.getElementById('currentCurrency');
//     const currentCurrencyBtnMobile = document.getElementById('currentCurrencyMobile');
//     const currencyOptions = document.querySelectorAll('.currency-option');
//     const currencyOptionsMobile = document.querySelectorAll('.mobile-view .currency-bar .dropdown-menu li a');
//
//     const savedCurrency = localStorage.getItem('selectedCurrency') || 'EUR';
//     const savedCurrencySymbol = localStorage.getItem('selectedCurrencySymbol') || '€';
//     updateCurrentCurrency(savedCurrency, savedCurrencySymbol);
//
//     currencyOptions.forEach(option => {
//         option.addEventListener('click', function(e) {
//             e.preventDefault();
//             let selectedCurrency = this.getAttribute('data-currency');
//             let selectedCurrencySymbol = this.getAttribute('data-currency-symbol');
//             updateCurrentCurrency(selectedCurrency, selectedCurrencySymbol);
//             localStorage.setItem('selectedCurrency', selectedCurrency);
//             localStorage.setItem('selectedCurrencySymbol', selectedCurrencySymbol);
//         });
//     });
//
//     currencyOptionsMobile.forEach(option => {
//         option.addEventListener('click', function(e) {
//             e.preventDefault();
//             let selectedCurrency = this.getAttribute('data-currency');
//             let selectedCurrencySymbol = this.getAttribute('data-currency-symbol');
//             updateCurrentCurrency(selectedCurrency, selectedCurrencySymbol);
//             localStorage.setItem('selectedCurrency', selectedCurrency);
//             localStorage.setItem('selectedCurrencySymbol', selectedCurrencySymbol);
//         });
//     });
//
//     function updateCurrentCurrency(currency, symbol) {
//         currentCurrencyBtn.textContent = `Currency: ${currency}`;
//         currentCurrencyBtnMobile.textContent = `Currency: ${symbol} ${currency}`;
//
//         currencyOptions.forEach(option => {
//             const listItem = option.closest('li');
//             if (option.getAttribute('data-currency') === currency) {
//                 listItem.style.display = 'none';
//             } else {
//                 listItem.style.display = 'block';
//
//                 a2aData.currency = currency;
//                 setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
//             }
//         });
//
//         currencyOptionsMobile.forEach(option => {
//             const listItem = option.closest('li');
//
//             if (option.getAttribute('data-currency') === currency) {
//                 listItem.style.display = 'none';
//             } else {
//                 listItem.style.display = 'block';
//
//                 a2aData.currency = currency;
//                 setLanguageCurrencyAuthCookie('a2a_data', a2aData, 'alps2alps.com', 365);
//             }
//         });
//
//         const languageCodeElement = document.querySelector('#currentLanguageMobile .language-code');
//         if (languageCodeElement) {
//             languageCodeElement.innerHTML = currency;
//         } else {
//             console.log('Element not found');
//         }
//
//         languageOptionsMobile.forEach(option => {
//             let code = option.querySelector('.code');
//
//             if (code) {
//                 console.log(currency);
//                 // If the span exists, update its content
//                 code.textContent = ' - ' + currency;
//             } else {
//                 console.log(currency);
//                 // If the span does not exist, create and append it
//                 const newCodeElement = document.createElement('span');
//                 newCodeElement.className = 'code';
//                 newCodeElement.textContent = ' - ' + currency;
//                 option.appendChild(newCodeElement);
//             }
//         });
//     }
// });
//
//
// //Setting cookies
// function setLanguageCurrencyAuthCookie(name, jsonData, domain, days) {
//     const value = JSON.stringify(jsonData); // Convert JSON object to a string
//     let expires = "";
//     if (days) {
//         const date = new Date();
//         date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
//         expires = "; expires=" + date.toUTCString();
//     }
//     document.cookie = name + "=" + encodeURIComponent(value) + expires + "; domain=" + domain + "; path=/";
// }
//
//
// // //Getting cookie values
// function getCookieValue(name) {
//     const match = document.cookie.match('(^|;)\\s*' + name + '=([^;]+)');
//     return match ? JSON.parse(decodeURIComponent(match[2])) : null;
// }

// Track Driver Popover Functionality
document.addEventListener('DOMContentLoaded', function() {
    const trackDriverContainers = document.querySelectorAll('.track-driver-container');
    let activePopover = null;

    trackDriverContainers.forEach(container => {
        const trackDriverLink = container.querySelector('.track-my-driver');
        const popover = container.querySelector('.track-driver-popover');

        if (!popover) return;

        // Check if mobile on each interaction (for dynamic resizing)
        trackDriverLink.addEventListener('click', function(e) {
            if (window.innerWidth <= 991) {
                // Mobile: Show popover, prevent navigation (use "Learn more" link instead)
                e.preventDefault();
                
                // Close any other active popover
                if (activePopover && activePopover !== popover) {
                    activePopover.style.opacity = '0';
                    activePopover.style.visibility = 'hidden';
                    const otherContainer = activePopover.closest('.track-driver-container');
                    if (otherContainer) otherContainer.classList.remove('show-popover');
                }

                // Toggle current popover
                if (container.classList.contains('show-popover')) {
                    container.classList.remove('show-popover');
                    popover.style.opacity = '0';
                    popover.style.visibility = 'hidden';
                    activePopover = null;
                } else {
                    container.classList.add('show-popover');
                    popover.style.opacity = '1';
                    popover.style.visibility = 'visible';
                    activePopover = popover;
                }
            } else {
                // Desktop: Show popover on click, but also allow navigation after a short delay
                e.preventDefault();
                
                // Close any other active popover
                if (activePopover && activePopover !== popover) {
                    activePopover.style.opacity = '0';
                    activePopover.style.visibility = 'hidden';
                    const otherContainer = activePopover.closest('.track-driver-container');
                    if (otherContainer) otherContainer.classList.remove('show-popover');
                }

                // Show popover
                container.classList.add('show-popover');
                popover.style.opacity = '1';
                popover.style.visibility = 'visible';
                activePopover = popover;

                // Navigate after showing popover
                setTimeout(() => {
                    window.location.href = trackDriverLink.href;
                }, 300);
            }
        });
    });

    // Close popover when clicking outside
    document.addEventListener('click', function(e) {
        if (activePopover && !e.target.closest('.track-driver-container')) {
            const container = activePopover.closest('.track-driver-container');
            if (container) container.classList.remove('show-popover');
            activePopover.style.opacity = '0';
            activePopover.style.visibility = 'hidden';
            activePopover = null;
        }
    });

    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 991 && activePopover) {
            const container = activePopover.closest('.track-driver-container');
            if (container) container.classList.remove('show-popover');
            activePopover.style.opacity = '0';
            activePopover.style.visibility = 'hidden';
            activePopover = null;
        }
        
        // Re-run device detection for all components on resize
        detectDeviceAndShowButton();
    });

    // Device detection for app store buttons
    function detectDeviceAndShowButton() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        
        // Mobile navigation app buttons
        const appStoreButton = document.getElementById('appStoreButton');
        const playStoreButton = document.getElementById('playStoreButton');
        
        // Track Driver App block mobile buttons
        const trackDriverMobileButtons = document.querySelectorAll('.track-driver-app-block .mobile-buttons');
        
        // Footer app buttons
        const footerContainer = document.getElementById('footer-app-buttons');

        // Check if mobile app buttons exist (they won't exist in fallback mode)
        if (appStoreButton && playStoreButton) {
            // Check if buttons have content
            const hasAppStoreContent = appStoreButton.innerHTML.trim() !== '';
            const hasPlayStoreContent = playStoreButton.innerHTML.trim() !== '';

            // If no buttons have content, don't show anything
            if (hasAppStoreContent || hasPlayStoreContent) {
                // iOS detection
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    if (hasAppStoreContent) {
                        appStoreButton.style.display = 'block';
                        playStoreButton.style.display = 'none';
                    } else if (hasPlayStoreContent) {
                        appStoreButton.style.display = 'none';
                        playStoreButton.style.display = 'block';
                    }
                }
                // Android detection
                else if (/android/i.test(userAgent)) {
                    if (hasPlayStoreContent) {
                        appStoreButton.style.display = 'none';
                        playStoreButton.style.display = 'block';
                    } else if (hasAppStoreContent) {
                        appStoreButton.style.display = 'block';
                        playStoreButton.style.display = 'none';
                    }
                }
                // Fallback to available button for all other devices
                else {
                    if (hasPlayStoreContent) {
                        appStoreButton.style.display = 'none';
                        playStoreButton.style.display = 'block';
                    } else if (hasAppStoreContent) {
                        appStoreButton.style.display = 'block';
                        playStoreButton.style.display = 'none';
                    }
                }
            }
        }

        // Track Driver App block mobile buttons device detection
        if (trackDriverMobileButtons.length > 0 && window.innerWidth <= 768) {
            trackDriverMobileButtons.forEach(buttonContainer => {
                const iosBtn = buttonContainer.querySelector('.mobile-ios-btn');
                const androidBtn = buttonContainer.querySelector('.mobile-android-btn');
                
                const hasIOSBtn = iosBtn && iosBtn.innerHTML.trim() !== '';
                const hasAndroidBtn = androidBtn && androidBtn.innerHTML.trim() !== '';
                
                // iOS detection
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    if (hasIOSBtn) {
                        iosBtn.style.display = 'block';
                        if (androidBtn) androidBtn.style.display = 'none';
                    } else if (hasAndroidBtn) {
                        if (iosBtn) iosBtn.style.display = 'none';
                        androidBtn.style.display = 'block';
                    }
                }
                // Android detection
                else if (/android/i.test(userAgent)) {
                    if (hasAndroidBtn) {
                        androidBtn.style.display = 'block';
                        if (iosBtn) iosBtn.style.display = 'none';
                    } else if (hasIOSBtn) {
                        iosBtn.style.display = 'block';
                        if (androidBtn) androidBtn.style.display = 'none';
                    }
                }
                // Fallback to available button for all other devices
                else {
                    if (hasAndroidBtn) {
                        androidBtn.style.display = 'block';
                        if (iosBtn) iosBtn.style.display = 'none';
                    } else if (hasIOSBtn) {
                        iosBtn.style.display = 'block';
                        if (androidBtn) androidBtn.style.display = 'none';
                    }
                }
            });
        }

        // App Tracker Banner block device detection (mobile only)
        const appTrackerBanners = document.querySelectorAll('.app-tracker-banner');
        if (appTrackerBanners.length > 0 && window.innerWidth <= 768) {
            appTrackerBanners.forEach(banner => {
                const storeBadges = banner.querySelector('.store-badges');
                if (!storeBadges) return;
                
                const appStoreMobile = storeBadges.querySelector('.desktop-hide.app-st-badge');
                const playStoreMobile = storeBadges.querySelector('.desktop-hide.g-pl-badge');
                
                const hasAppStoreMobile = appStoreMobile && appStoreMobile.innerHTML.trim() !== '';
                const hasPlayStoreMobile = playStoreMobile && playStoreMobile.innerHTML.trim() !== '';
                
                // iOS detection
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    console.log('iOS detection');
                    if (hasAppStoreMobile) {
                        appStoreMobile.style.display = 'block';
                        if (playStoreMobile) playStoreMobile.style.display = 'none';
                    } else if (hasPlayStoreMobile) {
                        if (appStoreMobile) appStoreMobile.style.display = 'none';
                        playStoreMobile.style.display = 'block';
                    }
                }
                // Android detection
                else if (/android/i.test(userAgent)) {
                    console.log('Android detection');
                    if (hasPlayStoreMobile) {
                        playStoreMobile.style.display = 'block';
                        if (appStoreMobile) appStoreMobile.style.display = 'none';
                    } else if (hasAppStoreMobile) {
                        appStoreMobile.style.display = 'block';
                        if (playStoreMobile) playStoreMobile.style.display = 'none';
                    }
                }
                // Fallback to available button for all other devices
                else {
                    if (hasPlayStoreMobile) {
                        playStoreMobile.style.display = 'block';
                        if (appStoreMobile) appStoreMobile.style.display = 'none';
                    } else if (hasAppStoreMobile) {
                        appStoreMobile.style.display = 'block';
                        if (playStoreMobile) playStoreMobile.style.display = 'none';
                    }
                }
            });
        }

        // Shuttle App Banner device detection (mobile only ≤1024px)
        const shuttleAppBanners = document.querySelectorAll('.shuttle-app-banner');
        if (shuttleAppBanners.length > 0 && window.innerWidth <= 1024) {
            shuttleAppBanners.forEach(banner => {
                const googlePlayContainer = banner.querySelector('.shuttle-app-banner__button-container--google');
                const appStoreContainer = banner.querySelector('.shuttle-app-banner__button-container--apple');
                
                const hasGooglePlay = googlePlayContainer && googlePlayContainer.innerHTML.trim() !== '';
                const hasAppStore = appStoreContainer && appStoreContainer.innerHTML.trim() !== '';
                
                // iOS detection
                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    if (hasAppStore) {
                        banner.classList.add('show-app-store');
                        banner.classList.remove('show-google-play');
                    } else if (hasGooglePlay) {
                        banner.classList.add('show-google-play');
                        banner.classList.remove('show-app-store');
                    }
                }
                // Android detection
                else if (/android/i.test(userAgent)) {
                    if (hasGooglePlay) {
                        banner.classList.add('show-google-play');
                        banner.classList.remove('show-app-store');
                    } else if (hasAppStore) {
                        banner.classList.add('show-app-store');
                        banner.classList.remove('show-google-play');
                    }
                }
                // Fallback to available button for all other devices
                else {
                    if (hasGooglePlay) {
                        banner.classList.add('show-google-play');
                        banner.classList.remove('show-app-store');
                    } else if (hasAppStore) {
                        banner.classList.add('show-app-store');
                        banner.classList.remove('show-google-play');
                    }
                }
            });
        }

        // Footer app buttons device detection (mobile only)
        if (footerContainer && window.innerWidth <= 575) {
            // Check if footer has mobile buttons available
            const footerAppStore = footerContainer.querySelector('.footer-mobile-button.appstore-button');
            const footerPlayStore = footerContainer.querySelector('.footer-mobile-button.playstore-button');
            
            const hasFooterAppStore = footerAppStore && footerAppStore.innerHTML.trim() !== '';
            const hasFooterPlayStore = footerPlayStore && footerPlayStore.innerHTML.trim() !== '';
            
            // iOS detection
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                if (hasFooterAppStore) {
                    footerContainer.classList.add('show-appstore');
                    footerContainer.classList.remove('show-playstore');
                } else if (hasFooterPlayStore) {
                    footerContainer.classList.add('show-playstore');
                    footerContainer.classList.remove('show-appstore');
                }
            }
            // Android detection
            else if (/android/i.test(userAgent)) {
                if (hasFooterPlayStore) {
                    footerContainer.classList.add('show-playstore');
                    footerContainer.classList.remove('show-appstore');
                } else if (hasFooterAppStore) {
                    footerContainer.classList.add('show-appstore');
                    footerContainer.classList.remove('show-playstore');
                }
            }
            // Fallback to Play Store for all other devices (same as header logic)
            else {
                if (hasFooterPlayStore) {
                    footerContainer.classList.add('show-playstore');
                    footerContainer.classList.remove('show-appstore');
                } else if (hasFooterAppStore) {
                    footerContainer.classList.add('show-appstore');
                    footerContainer.classList.remove('show-playstore');
                }
            }
        }
    }

    // Run device detection on load
    detectDeviceAndShowButton();
});
